import {isSmlDevice} from '../util/device';

const subMenus = ()=> {
	// Sub menu revealing on mobile
	$(document).on('click', '.menu-item-has-children', function() {
		$(this).parent('.sub-menu').removeClass('overflow-y-class');
	});
	
	$('.menu-item-has-children').on('click', function(event) {
		if (isSmlDevice(768)) {
			event.preventDefault();
			var $parent = $(this);
			var $submenu = $parent.children('.sub-menu');
			$submenu.addClass('is-visible');

			$(this).children('.sub-menu').addClass('overflow-y-class');

			$('html').addClass('subnav-showing');
			$('.sub-menu').scrollTop(0);
		}
	});

	$('.sub-menu a').on('click', function(event) {
		event.stopPropagation();
	});

	$('body').on('click', '.js-backsubmenu', function(event) {
		event.stopPropagation();
		event.preventDefault();
		$(this).closest('.sub-menu').removeClass('is-visible overflow-y-class');
		const $targetElement = $(this).parents('.is-visible');

		$targetElement.addClass(' overflow-y-class ');
	});

	// Add back button to the top of each sub nav menu
	$('.mainnav .sub-menu').prepend('<li><button class="btnback js-backsubmenu"><i></i>Back</button></li>');


	$('.menu-item').each(function() {
        var subText = $(this).find('a').attr('data-sub-text');
        if (subText !== undefined) {
            // Find the <span> element within the menu item and set its text content
            $(this).find('.sub_text').text(subText);
        }
    });

}

const toggleNav = ($el) => {
  const $html = $('html');
	if (!$el.hasClass('is-active')) {
		$el.addClass('is-active');
		$html.addClass('nav-toggled');
		$('.togglenav__text').text('Close');
	} else {
		$el.removeClass('is-active');
		$html.removeClass('nav-toggled');
		$('.togglenav__text').text('Menu');
		// Reset sub menus on mobile
		// hideSubNav();
	}
}

export default {
  init() {
    $('body').on('click', '.js-togglenav', function(event) {
      event.preventDefault();
      toggleNav($(this));
    });

    subMenus();
  },
}


// WEBPACK FOOTER //
// ./scripts/components/nav.js